import {Alert, InputAdornment, MenuItem, Select, Stack, TextField, Typography} from "@mui/material";
import * as React from "react";
import {useEffect, useState} from "react";
import {LoadingButton} from "@mui/lab";
import {countries} from "../countries";
//@ts-ignore
import {FixedSizeList} from "react-window";
//@ts-ignore
import InputMask from "react-input-mask"
import axios from "axios";
import {API_URL} from "../App";
import {useTranslation} from "i18nano";

interface PhoneNumberCommonComponentProps {
    onClick: (phoneNumber: string) => void;
    loading: boolean;
    errors?: string[];
}

const PhoneNumberCommonComponent: React.FC<PhoneNumberCommonComponentProps> = ({onClick, loading, errors = []}) => {
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [country, setCountry] = useState<string>("US")
    const [open, setOpen] = useState<boolean>(false);
    const [selectLoading, setSelectLoading] = useState<boolean>(false);
    const [lastDateSendSms, setLastDateSendSms] = useState<number>(0);
    const t = useTranslation();
    const changeCountry = (code: string) => {
        setTimeout(() => setOpen(false), 500)
        setCountry(code);
    }

    function renderRow(props: any) {
        const {index, style} = props;
        const country = countries[index];

        return (<MenuItem style={style}
                          onClick={() => changeCountry(country.code)}
                          key={country.code}
                          value={country.code}>
                <img
                    loading="lazy"
                    width="20"
                    src={`https://flagcdn.com/w20/${country.code.toLowerCase()}.png`}
                    srcSet={`https://flagcdn.com/w40/${country.code.toLowerCase()}.png 2x`}
                    alt=""
                    style={{marginRight: 10}}
                />
                {country.label} (+{country.phone})
            </MenuItem>
        );
    }


    useEffect(() => {
        setSelectLoading(true);
        let lastTime = localStorage.getItem("lastSendSms");
        if (lastTime) {
            setLastDateSendSms(+lastTime + 60 * 1000);
        }
        axios.get(`${API_URL}/user/country`)
            .then(response => {
                setCountry(response.data.data.countryCode);
                setSelectLoading(false);
            })
            .catch(() => {
                setSelectLoading(false);
            })
    }, [])

    const [currentTime, setCurrentTime] = useState<number>(new Date().getTime());

    useEffect(() => {
        if (lastDateSendSms <= 0) return;

        const interval = setInterval(() => {
            const now = new Date().getTime();
            setCurrentTime(now);

            if (lastDateSendSms <= now) {
                setLastDateSendSms(0);
                clearInterval(interval);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [lastDateSendSms]);
    return (
        <Stack
            spacing={2}
            justifyContent={'center'}
            sx={{
                background: `white`,
                padding: `32px 26px`,
                borderRadius: `12px`,
                boxShadow: `0 4px 6px rgba(0, 0, 0, 0.02),
                    0 10px 24px rgba(0, 0, 0, 0.06),
                    0 0 0 1px rgba(0, 0, 0, 0.02);`}}
        >
            <Typography variant="h4" align={'center'}>
                {t("Enter phone number")}
            </Typography>
            <Typography variant="body1" gutterBottom align={"center"}>
                {t("Please confirm your country code and enter your phone number")}
            </Typography>
            <Select
                defaultValue={'US'}
                value={country}
                open={open}
                disabled={selectLoading}
                onClick={() => setOpen(prev => !prev)}
            >
                <MenuItem sx={{display: "none"}} value={countries[countries.findIndex(a => a.code === country)].code}>
                    <img
                        loading="lazy"
                        width="20"
                        src={`https://flagcdn.com/w20/${countries[countries.findIndex(a => a.code === country)].code.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${countries[countries.findIndex(a => a.code === country)].code.toLowerCase()}.png 2x`}
                        alt=""
                        style={{marginRight: 10}}
                    />
                    {countries[countries.findIndex(a => a.code === country)].label}
                </MenuItem>
                <FixedSizeList
                    height={300}
                    width={400}
                    itemSize={46}
                    itemCount={countries.length}
                    overscanCount={15}
                >
                    {renderRow}
                </FixedSizeList>
            </Select>
            <InputMask mask={`## ### ## ###`}
                       value={phoneNumber}
                       onChange={(e: any) => setPhoneNumber(e.target.value)}
                       maskChar={""}
                       formatChars={{
                           '#': '[0-9]'
                       }}
                       InputProps={{
                           startAdornment: <InputAdornment position="start">
                               {"+" + countries[countries.findIndex(a => a.code === country)].phone}
                           </InputAdornment>,
                       }}
                       onKeyPress={(e: any) => {
                           if (e.code === "Enter") {
                               if (phoneNumber !== "" ||
                                   phoneNumber.replaceAll(" ", "").length < 6 ||
                                   (lastDateSendSms > new Date().getTime())
                               ) {
                                   onClick(("+" + countries[countries.findIndex(a => a.code === country)].phone + phoneNumber).replaceAll(" ", ""))
                               }
                           }
                       }}
            >
                {(inputProps: any) => <TextField {...inputProps} type="tel"/>}
            </InputMask>

            {errors.map(e => <Alert severity="error">{e}</Alert>)}

            <LoadingButton variant="contained"
                           disabled={phoneNumber === "" ||
                               phoneNumber.replaceAll(" ", "").length < 6 ||
                               (lastDateSendSms > currentTime)}
                           onClick={() => onClick(("+" + countries[countries.findIndex(a => a.code === country)].phone + phoneNumber).replaceAll(" ", ""))}
                           loading={loading} size={"large"} loadingPosition="start" startIcon={<></>}
            >
                {lastDateSendSms > new Date().getTime() ?
                    t("You can send code again after seconds", {seconds: `${new Date(lastDateSendSms - new Date().getTime()).getSeconds()}`})
                    :
                    t("Next")}
            </LoadingButton>
        </Stack>
    )

}

export default PhoneNumberCommonComponent